<template>
	<div>
		<v-autocomplete
			:class="dense ? 'grv-input-dense' : 'grv-input'"
			class="chiped-input"
			:menu-props="{contentClass: 'grv-menu'}"
			:rules="rules"
			@update:error="errored = $event"
			:value="value"
			clearable
			:items="items"
			:loading="loading"
			item-text="1"
			item-value="0"
			:name="param.name"
			:search-input.sync="search"
			:readonly="readonly"
			auto-select-first
			:dense="dense"
			no-filter
			hide-no-data
			chips
			:small-chips="dense"
			:deletable-chips="!readonly"
			:placeholder="items.length ? 'Selectionner un patron' : 'Rechercher un Patron'"
			@change="$emit('update:value', $event)">

			<template v-slot:label>
				<Label :param="param"></Label>
			</template>
		</v-autocomplete>

		<Hint :param="param" :errored="errored"></Hint>
	</div>
</template>

<script>
import { debounce } from 'debounce'
import Label from '@/components/fields/label.vue'
import Hint from '@/components/fields/hint.vue'
export default {
	props: [
		'param',
		'value',
		'readonly',
		'dense'
	],
	components: {
		Label,
		Hint
	},
	data () {
		return {
			rules: [],
			errored: false,
			items: [],
			uids: [],
			descriptions: [],
			search: null,
			loading: false,
			has_choices: false
		}
	},
	watch: {
		search (val) {
			if (val &&
				this.descriptions.indexOf(val) === -1 &&
				this.param.choices.length === 0) {
				this.patronSearch(val)
			}
		},
		value (val) {
			if (val && this.uids.indexOf(val) === -1) {
				this.getPatron(val)
			}
		}
	},
	methods: {
		patronSearch: debounce(function (search) {
			if (!search) return
			if (search.length < 2) return
			if (this.loading) return
			this.getPatrons(search)
		}, 100),
		getPatrons (search) {
			if (this.has_choices) return
			this.loading = true
			this.$EsMaestro.patron_search(search)
				.then(patrons => {
					this.items = patrons.map(patron => [patron.uid, patron.description])
					this.uids = patrons.map(patron => patron.uid)
					this.descriptions = patrons.map(patron => patron.description)
					if (patrons.length === 1) {
						let value = patrons[0].uid
						if (search === value) {
							this.$emit('update:value', value)
						}
					}
				})
				.catch(err => { console.log(err) })
				.finally(() => { this.loading = false })
		},
		getPatron (id) {
			if (this.has_choices) return
			this.loading = true
			this.$EsMaestro.patron_read(id)
				.then(patrons => {
					this.items = patrons.map(patron => [patron.uid, patron.description])
					this.uids = patrons.map(patron => patron.uid)
					this.descriptions = patrons.map(patron => patron.description)
				})
				.catch(err => { console.log(err) })
				.finally(() => { this.loading = false })
		},
		requiredCheck (value) {
			if (value === '') return 'Requis'
			if (value === null) return 'Requis'
			if (value === undefined) return 'Requis'
			return true
		}
	},
	mounted () {
		if (!this.param) return
		if (this.param.required || this.param.required === undefined) {
			this.rules.push(this.requiredCheck)
		}
		if (this.param.choices.length > 0) {
			this.items = this.param.choices
			this.has_choices = true
		}
		if (this.value) this.getPatron(this.value)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/fields/patronid.vue